import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Layout from '../layout/Layout';
import HeroSection from '../sections/HeroSection';
import OurClientsSection from '../sections/OurClientsSection';
// import FeaturesSection from '../sections/FeaturesSection';
import CoreFeaturesSection from '../sections/CoreFeaturesSection';
import WhyChooseSection from '../sections/WhyChooseSection';
import JourneyPreviewSection from '../sections/JourneyPreviewSection';
// import ConsultationPackagesSection from '../sections/ConsultationPackagesSection';
// import TestimonialsSection from '../sections/TestimonialsSection';
// import ScholarshipsSection from '../sections/ScholarshipsSection';
import CommunitySection from '../sections/CommunitySection';
import FinalCTASection from '../sections/FinalCTASection';

export default function Home() {
  const { isAuthenticated, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Redirect to dashboard if user is already logged in
    if (!loading && isAuthenticated) {
      navigate('/dashboard', { replace: true });
    }
  }, [isAuthenticated, loading, navigate]);

  useEffect(() => {
    if (!location.hash) return;

    const targetId = location.hash.slice(1);
    if (!targetId) return;

    const target = document.getElementById(targetId);
    if (!target) return;

    const headerOffset = 96;
    const targetTop = target.getBoundingClientRect().top + window.pageYOffset - headerOffset;
    window.scrollTo({ top: targetTop, behavior: 'smooth' });
  }, [location.hash]);

  // Show nothing while checking authentication or if authenticated
  if (loading || isAuthenticated) {
    return null;
  }

  return (
    <Layout>
      <HeroSection />
      <div id="clients">
        <OurClientsSection />
      </div>
      <div id="about">
        {/* <FeaturesSection /> */}
        <CoreFeaturesSection />
      </div>
      <WhyChooseSection />
      <JourneyPreviewSection />
      {/* <div id="services">
        <ConsultationPackagesSection />
      </div> */}
      {/* <TestimonialsSection /> */}
      {/* <div id="scholarships">
        <ScholarshipsSection />
      </div> */}
      <div id="community">
        <CommunitySection />
      </div>
      <div id="contact">
        <FinalCTASection />
      </div>
    </Layout>
  );
}
